


































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { broadcastTypes } from "@/config/channels/channel-types.config.json";

@Component({})
export default class ChannelTypeDropdown extends Vue {
  @Prop({ type: String, default: "PRO" }) dropType!: string;
  channelTypes = broadcastTypes;
  type = this.dropType;

  @Watch("dropType")
  updateType(): void {
    this.type = this.dropType;
  }
}
